import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import cn from 'classnames';
import { useState } from 'react';
import { FilterSVG } from '@sbercloud/uikit-product-icons';
import { MobileDroplist } from '@sbercloud/uikit-product-mobile-dropdown';
import { AdaptiveFieldSelect } from '@sbercloud/uikit-product-mobile-fields';
import { MobileModalCustom } from '@sbercloud/uikit-product-mobile-modal';
import { LAYOUT_TYPE } from '@sbercloud/uikit-product-utils';
import { ButtonFilled } from '@snack-uikit/button';
import { Card } from '@snack-uikit/card';
import { Divider } from '@snack-uikit/divider';
import { List } from '@snack-uikit/list';
import { ModalCustom } from '@snack-uikit/modal';
import { Tag } from '@snack-uikit/tag';
import { Tooltip } from '@snack-uikit/tooltip';
import { useCalculatorContext } from '../../contexts';
import { useCatalogCardClick } from '../../hooks';
import { parseKeyToDataTest } from '../../utils';
import { PrivateCardHeader } from './components';
import styles from "./styles.module.css";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var bannerText = {
  "public": 'Доступна всем',
  request: 'Для всех, по заявке',
  legal: 'Только для юрлиц'
};
export function Catalog() {
  var _config$catalog$selec, _config$catalog$selec2, _config$catalog$selec3, _config$catalog$selec4;
  var _useCalculatorContext = useCalculatorContext(),
    selectedPlatform = _useCalculatorContext.selectedPlatform,
    setSelectedPlatform = _useCalculatorContext.setSelectedPlatform,
    setSelectedCategory = _useCalculatorContext.setSelectedCategory,
    selectedCategory = _useCalculatorContext.selectedCategory,
    products = _useCalculatorContext.products,
    _useCalculatorContext2 = _useCalculatorContext.layoutType,
    layoutType = _useCalculatorContext2 === void 0 ? LAYOUT_TYPE.Desktop : _useCalculatorContext2,
    config = _useCalculatorContext.config,
    catalogOpen = _useCalculatorContext.catalogOpen,
    setCatalogOpen = _useCalculatorContext.setCatalogOpen,
    onPlatformSelect = _useCalculatorContext.actions.onPlatformSelect;
  var handleCatalogCardClick = useCatalogCardClick();
  var handlePlatformChange = function handlePlatformChange(platformId) {
    onPlatformSelect === null || onPlatformSelect === void 0 ? void 0 : onPlatformSelect(platformId);
    setSelectedPlatform(platformId);
    setSelectedCategory(config.catalog[platformId][0].id);
  };
  var categoryOptions = config.catalog[selectedPlatform].map(function (_ref) {
    var id = _ref.id,
      dataTestId = _ref.dataTestId,
      label = _ref.label;
    return {
      id: id,
      content: {
        option: label
      },
      'data-test-id': dataTestId
    };
  });
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    openMobileCategory = _useState2[0],
    setOpenMobileCategory = _useState2[1];
  var isMobile = layoutType !== LAYOUT_TYPE.Desktop && layoutType !== LAYOUT_TYPE.DesktopSmall;
  var AdaptiveModal = isMobile ? MobileModalCustom : ModalCustom;
  return /*#__PURE__*/_jsxs(AdaptiveModal, {
    open: catalogOpen
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    ,
    size: "l",
    onClose: function onClose() {
      setCatalogOpen === null || setCatalogOpen === void 0 ? void 0 : setCatalogOpen(false);
    },
    className: cn(_defineProperty({}, styles.modal, !isMobile)),
    "data-test-id": parseKeyToDataTest('catalog'),
    children: [/*#__PURE__*/_jsx(AdaptiveModal.Header, {
      title: "\u041A\u0430\u0442\u0430\u043B\u043E\u0433 \u043F\u0440\u043E\u0434\u0443\u043A\u0442\u043E\u0432"
    }), /*#__PURE__*/_jsx(AdaptiveModal.Body, {
      content: /*#__PURE__*/_jsxs("div", {
        className: styles.wrapper,
        "data-mobile": isMobile || undefined,
        children: [/*#__PURE__*/_jsxs("div", {
          className: styles.sidebar,
          children: [/*#__PURE__*/_jsx(AdaptiveFieldSelect, {
            layoutType: layoutType,
            value: selectedPlatform,
            onChange: handlePlatformChange,
            size: "m",
            label: "\u041E\u0431\u043B\u0430\u0447\u043D\u0430\u044F \u043F\u043B\u0430\u0442\u0444\u043E\u0440\u043C\u0430",
            widthStrategy: "eq",
            searchable: false,
            showClearButton: false,
            options: config.platforms.map(function (_ref2) {
              var icon = _ref2.icon,
                description = _ref2.description,
                id = _ref2.id,
                label = _ref2.label,
                dataTestId = _ref2.dataTestId,
                access = _ref2.access;
              return {
                value: id,
                beforeContent: icon,
                truncate: {
                  option: 2,
                  description: 3,
                  variant: 'end'
                },
                'data-test-id': dataTestId,
                option: label,
                description: /*#__PURE__*/_jsxs("div", {
                  className: styles.description,
                  children: [/*#__PURE__*/_jsxs("span", {
                    children: [description, " "]
                  }), /*#__PURE__*/_jsx("div", {
                    children: /*#__PURE__*/_jsx(Tag, {
                      label: bannerText[access],
                      appearance: "green"
                    })
                  })]
                })
              };
            })
          }), !isMobile && /*#__PURE__*/_jsxs("div", {
            className: styles.categoriesWrapper,
            children: [/*#__PURE__*/_jsx(Divider, {
              orientation: "vertical"
            }), /*#__PURE__*/_jsx(List, {
              size: "m",
              items: categoryOptions,
              selection: {
                value: selectedCategory,
                onChange: function onChange(value) {
                  return value && setSelectedCategory(value);
                },
                mode: 'single'
              }
            })]
          })]
        }), /*#__PURE__*/_jsxs("div", {
          className: styles.content,
          children: [/*#__PURE__*/_jsx("div", {
            className: styles.contentHeadline,
            "data-test-id": parseKeyToDataTest('catalog', 'category-title'),
            children: (_config$catalog$selec = config.catalog[selectedPlatform].find(function (item) {
              return item.id === selectedCategory;
            })) === null || _config$catalog$selec === void 0 ? void 0 : _config$catalog$selec.label
          }), /*#__PURE__*/_jsxs("div", {
            className: styles.contentCards,
            children: [((_config$catalog$selec2 = config.catalog[selectedPlatform].find(function (item) {
              return item.id === selectedCategory;
            })) === null || _config$catalog$selec2 === void 0 ? void 0 : _config$catalog$selec2.banner) || null, (_config$catalog$selec3 = config.catalog[selectedPlatform].find(function (item) {
              return item.id === selectedCategory;
            })) === null || _config$catalog$selec3 === void 0 ? void 0 : _config$catalog$selec3.visibleProducts.map(function (productId) {
              return config.products[productId];
            }).filter(Boolean).map(function (product) {
              var disabled = product.freeTier && Object.keys(products).includes(product.id);
              return /*#__PURE__*/_jsx(Card, {
                className: styles.card,
                size: isMobile ? 's' : 'm',
                outline: true,
                disabled: disabled,
                onClick: disabled ? undefined : function () {
                  return handleCatalogCardClick === null || handleCatalogCardClick === void 0 ? void 0 : handleCatalogCardClick(product.id);
                },
                promoBadge: disabled ? {
                  text: 'Добавлен',
                  appearance: 'green'
                } : undefined,
                header: /*#__PURE__*/_jsx(Tooltip, {
                  open: disabled ? undefined : false,
                  tip: 'Free tier продукты можно добавить только один раз. Чтобы посмотреть конфигурацию продукта, кликните на его карточку в расчете',
                  children: /*#__PURE__*/_jsx(PrivateCardHeader, {
                    icon: product === null || product === void 0 ? void 0 : product.icon,
                    title: product === null || product === void 0 ? void 0 : product.label,
                    metadata: product === null || product === void 0 ? void 0 : product.caption,
                    description: product !== null && product !== void 0 && product.freeTier ? /*#__PURE__*/_jsx("div", {
                      className: styles.tag,
                      "data-test-id": parseKeyToDataTest('catalog', 'card-tag'),
                      children: /*#__PURE__*/_jsx(Tag, {
                        label: "\u0411\u0435\u0441\u043F\u043B\u0430\u0442\u043D\u0430\u044F \u043A\u043E\u043D\u0444\u0438\u0433\u0443\u0440\u0430\u0446\u0438\u044F",
                        appearance: "green"
                      })
                    }) : null
                  })
                }),
                "data-test-id": parseKeyToDataTest('catalog', 'card')
              }, product.id);
            })]
          })]
        })]
      })
    }), isMobile && /*#__PURE__*/_jsx(AdaptiveModal.Footer, {
      actions: /*#__PURE__*/_jsx(MobileDroplist, {
        open: openMobileCategory,
        onOpenChange: setOpenMobileCategory,
        items: categoryOptions,
        selection: {
          value: selectedCategory,
          onChange: function onChange(value) {
            setSelectedCategory(value);
            setOpenMobileCategory(false);
          },
          mode: 'single'
        },
        label: "\u041A\u0430\u0442\u0435\u0433\u043E\u0440\u0438\u0438",
        size: "l",
        children: /*#__PURE__*/_jsx("div", {
          className: styles.categoriesWrapper,
          children: /*#__PURE__*/_jsx(ButtonFilled, {
            size: "m",
            appearance: "neutral",
            icon: /*#__PURE__*/_jsx(FilterSVG, {}),
            label: "\u041A\u0430\u0442\u0435\u0433\u043E\u0440\u0438\u0438: ".concat((_config$catalog$selec4 = config.catalog[selectedPlatform].find(function (item) {
              return item.id === selectedCategory;
            })) === null || _config$catalog$selec4 === void 0 ? void 0 : _config$catalog$selec4.label)
          })
        })
      })
    })]
  });
}